module.exports = __webpack_public_path__ + "media/images/gallery/constellations/draco/dra_vis-1ec8eea08ce817207fc145dc6b291425.jpg";